import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const COLUMNSBLOCK_LEGACY_FIELD_ORDER = [
  "columns_count",
  "gap",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  columnsBlockDescriptor: _generatedColumnsBlockDescriptor,
  columnsBlockBlocDefinition,
  columnsBlockDashboardLayout,
  columnsBlockConfig,
  columnsBlockResolveConfig,
  columnsBlockProperties,
} = doodBlockConfig(
  {
    name: "Columns",
    componentType: "ColumnsBlockComponent",
    category: "layout",
    description: "Multi-column container.",
    keywords: ["columns", "layout", "grid"],
    hideFromPicker: true,
    sharedFields: {
      props: [
        { name: "columns_count", type: "number" },
        { name: "gap", type: "slider" },
      ],
    },
    slots: [
      {
        key: "left",
        name: "pages.blocks.columns.left.label",
        accept: "explicitOnly",
        allowedTypes: [
          "TextBlockComponent",
          "ButtonBlockComponent",
          "ImageFullWidthBlockComponent",
          "SpacerBlockComponent",
        ],
        slotItemFormat: "ids",
      },
      {
        key: "right",
        name: "pages.blocks.columns.right.label",
        accept: "explicitOnly",
        allowedTypes: [
          "TextBlockComponent",
          "ButtonBlockComponent",
          "ImageFullWidthBlockComponent",
          "SpacerBlockComponent",
        ],
        slotItemFormat: "ids",
      },
    ],
  },

  shared => ({
    columns_count: propertyValue({
      type: shared.props.columns_count,
      value: 2,
      options: {
        label: "pages.blocks.columns.columns-count.label",
        min: 1,
        max: 4,
      },
    }),
    gap: propertyValue({
      type: shared.props.gap,
      value: 16,
      options: {
        label: "pages.blocks.columns.gap.label",
        min: 0,
        max: 64,
        step: 4,
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.columns.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.columns.fieldset.layout.label",
            fields: ["columns_count", "gap"],
          },
        ],
      },
    ],
  })
);

export function columnsBlockDescriptor(): IBlockDescriptor;
export function columnsBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function columnsBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedColumnsBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedColumnsBlockDescriptor,
    columnsBlockProperties,
    fieldOrder,
  );
}

export {
  columnsBlockBlocDefinition,
  columnsBlockDashboardLayout,
  columnsBlockProperties,
  columnsBlockConfig,
  columnsBlockResolveConfig,
};

export type ColumnsBlockConfig = typeof columnsBlockConfig;
